import React from 'react';
import { t } from 'Src/i18n';
import { InputButton } from 'Components/frameworks/form-inputs/input-button/InputButton';
import { TemplateString } from 'Components/frameworks/template-string/TemplateString';
type Props = {
  children: React.ReactNode;
  className?: string;
  isActive?: boolean;
  isDisabled?: boolean;
  onClear: () => void;
  onClick: () => void;
  selectedOptionsNumber?: number;
};
export const FilterToggler = ({
  children,
  className,
  isActive,
  isDisabled,
  onClear,
  onClick,
  selectedOptionsNumber = 0,
}: Props) => (
  <InputButton
    className={className}
    isActive={isActive}
    isDisabled={isDisabled}
    isFilled={Boolean(selectedOptionsNumber)}
    onClear={onClear}
    onClick={onClick}
  >
    <span className="truncate">
      {children}
      {!!selectedOptionsNumber && (
        <TemplateString
          className="sr-only"
          template={
            selectedOptionsNumber > 1
              ? t('common.selectedCriteriasLabel.n')
              : t('common.selectedCriteriasLabel._1')
          }
          values={{
            count: selectedOptionsNumber.toString(),
          }}
        />
      )}
    </span>
  </InputButton>
);
